export default "__VITE_ASSET__CKxTPurB__"